import { Link } from 'react-router-dom';
import './Progetti.css';

function Progetti() {
    return (
        <div className='progetti-container'>
            <h1 className='progetti-title'>Progetti</h1>

            <p>
                Ecco i progetti realizzati dall'Associazione Settemotivi – ODV in onda su Radio Cosmo:
            </p>

            <ul className='progetti-list'>
                <li>
                    <Link to='/progetto-voce-volontari' className='progetti-card'>
                        <span>La Voce dei Volontari nella Comunità 2021-2022</span>
                        <span className='progetti-card-arrow' aria-hidden='true'>&#x27A2;</span>
                    </Link>
                </li>
                <li>
                    <Link to='/progetto-donna' className='progetti-card'>
                        <span>Donna: quando il tuo corpo ti tradisce 2022-2023</span>
                        <span className='progetti-card-arrow' aria-hidden='true'>&#x27A2;</span>
                    </Link>
                </li>
                <li>
                    <Link to='/progetto-locali-storici' className='progetti-card'>
                        <span>Locali storici del Friuli Venezia Giulia 2023-2024</span>
                        <span className='progetti-card-arrow' aria-hidden='true'>&#x27A2;</span>
                    </Link>
                </li>
                <li>
                    <Link to='/progetto-biblioteche' className='progetti-card'>
                        <span>Le Biblioteche pordenonesi 2024-2025</span>
                        <span className='progetti-card-arrow' aria-hidden='true'>&#x27A2;</span>
                    </Link>
                </li>
                <li>
                    <Link to='/progetto-spasso-fvg' className='progetti-card'>
                        <span>A Spasso per il Friuli Venezia Giulia 2025-2026</span>
                        <span className='progetti-card-arrow' aria-hidden='true'>&#x27A2;</span>
                    </Link>
                </li>
            </ul>
        </div>
    );
}

export default Progetti;
